export const DEFAULT_CONDITION_MULTIPLIERS = {
  NM: 1,
  LP: 0.8,
  MP: 0.64,
  HP: 0.512,
  DM: 0.4096,
};

export function getConditionMultipliers(userSettings) {
  const supplied = userSettings?.condition_multipliers;
  if (!supplied || typeof supplied !== 'object') {
    return { ...DEFAULT_CONDITION_MULTIPLIERS };
  }
  const result = { ...DEFAULT_CONDITION_MULTIPLIERS };
  for (const condition of Object.keys(DEFAULT_CONDITION_MULTIPLIERS)) {
    const raw = supplied[condition] ?? supplied[condition.toLowerCase()];
    const parsed = Number.parseFloat(raw);
    if (Number.isFinite(parsed)) {
      result[condition] = Math.min(1, Math.max(0, parsed));
    }
  }
  result.DMG = result.DM;
  result.D = result.DM;
  return result;
}

export function getConditionMultiplier(userSettings, condition) {
  const key = String(condition || 'NM').toUpperCase();
  return getConditionMultipliers(userSettings)[key] ?? 1;
}
